var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgIconSupportTicket = function SvgIconSupportTicket(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.999,
    height: 37.214,
    viewBox: "0 0 62 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line-support {\n        fill: none;\n        stroke: #ffffff;\n        stroke-linecap: round;\n        stroke-width: 2px;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-support-ticket",
    transform: "translate(-1.486 -0.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "line-support",
    d: "M413.33,240.4a5.779,5.779,0,0,1,0-11.538s.057-2.268,0-7.867H360c.05,1.521,0,8,0,8a5.779,5.779,0,0,1,0,11.538c0,2.413.05,4.779,0,8.26h53.33S413.315,241.183,413.33,240.4Z",
    transform: "translate(-384.606 -159.253) rotate(-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "line-support",
    d: "M399.645,227l2.825,5.723,6.316.918-4.57,4.455,1.079,6.291-5.649-2.97L394,244.387l1.079-6.291-4.57-4.455,6.316-.918Z",
    transform: "translate(-397.423 -157.952) rotate(-8)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSupportTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-support-ticket.30499214.svg";
export { ForwardRef as ReactComponent };